import { ofType } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal-compatibility';
import { of, forkJoin } from 'rxjs';
import {
  GET_COMPANY_METADATA,
  GET_COMPANY_METADATA_ERROR,
  SET_COMPANY_METADATA,
} from '@actions/company';
import { get_isCarrierOndDeck, getCompanyInfo } from '@api/directOffers';
import { get } from 'lodash';
import { COMPANY_SYNDICATION_STATES } from '@reducers/company';

export const getCompanyMetadata = action$ =>
  action$.pipe(
    ofType(GET_COMPANY_METADATA),
    switchMap(action => {
      const {
        apiUrl,
        companyKey,
        authenticationToken,
        isWhiteListed,
        baseUrl,
      } = action.payload;
      return forkJoin([
        fromPromise(
          get_isCarrierOndDeck(apiUrl, companyKey, authenticationToken),
        ),
        fromPromise(getCompanyInfo(baseUrl, companyKey)),
      ]).pipe(
        map(([carrier_response, company_response]) => {
          const payload = {
            isWhiteListed,
            name: get(carrier_response, ['data', 'name'], ''),
            logo: get(carrier_response, ['data', 'logo'], ''),
            is_on_deck: get(carrier_response, ['data', 'is_on_deck'], ''),
            syndicationState:
              get(company_response, [
                'data',
                'parade_public_loadboard_enabled',
              ]) === true
                ? COMPANY_SYNDICATION_STATES.SUPPORTED
                : COMPANY_SYNDICATION_STATES.NO_SUPPORT,
            is_placeholder: get(company_response, ['data', 'is_placeholder']),
            overrideEmail: get(
              company_response,
              ['data', 'quickview_override_email'],
              '',
            ),
            overridePhone: get(
              company_response,
              ['data', 'quickview_override_phone'],
              '',
            ),
          };
          return { type: SET_COMPANY_METADATA, payload };
        }),
        catchError(err => {
          var status = get(err, ['response', 'status'], '');
          if (status) {
            return of({
              type: GET_COMPANY_METADATA_ERROR,
              payload: { status },
            });
          } else {
            return of({ type: GET_COMPANY_METADATA_ERROR, payload: err });
          }
        }),
      );
    }),
  );
